<template>
    <div>
        <div class="egtd">
            <div class="widget" id="widget_1"></div>
            <div class="widget" v-if="!isMobile" id="widget_2"></div>
            <div class="widget" id="widget_3"></div>
        </div>
        <br>
        <div class="egtd" v-if="isMobile">
            <div class="widget" id="widget_2"></div>
        </div>
    </div>
</template>
<style lang="scss">  
    .jp_horizontal_panel .jp_horizontal_container{
        justify-content: space-between !important;
    }
    #app.mobile .egtd{ 
        display: flex;
        margin: 0 5px;
        .widget{
            width: 100%;
            display: inline-block;
            padding: 5px;
            margin-bottom: 20px !important;
            .jp_card_compact_container{
                max-width: 100% !important;
            }
        }
    }
    .egtd_jpw_hover_popup .egtd_jpw_hover_popup_inner{
        background: var(--client-footer) !important;
         .egtd_jpw_hp_logo_container{
            background: #ffffff15 !important;
        }
    }
</style>
<script>
import { isMobile } from 'mobile-device-detect';
export default {
    name: 'JackpotWidget',
    mounted() {
        const script = document.createElement('script');
        script.src = 'https://cdn.wlstorages.com/providers/egtd/jackpot/static/js/egtd_jpw_all.bundle.js?2';
        script.async = true;
        
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.wlstorages.com/providers/egtd/jackpot/static/css/egtd_jpw_all.bundle.css';
        
        // Append CSS to head
        document.head.appendChild(link);
        
        // When script is loaded, initialize widget
        script.onload = () => {
            const widget_1 = document.getElementById('widget_1');
            const widget_2 = document.getElementById('widget_2');
            const widget_3 = document.getElementById('widget_3');
            if (window.EGTD_JackpotWidget) {
                window.EGTD_JackpotWidget({
                    el: widget_1,
                    type: !isMobile  ? 'horizontal' : 'compact-card',
                    jackpot: 'Clover Chance',
                    currency: 'TRY',
                    apiHost: process.env.VUE_APP_EGT_URL
                });
                window.EGTD_JackpotWidget({
                    el: widget_2,
                    type: !isMobile  ? 'horizontal' : 'standart',
                    jackpot: 'Bell Link',
                    currency: 'TRY',
                    apiHost: process.env.VUE_APP_EGT_URL
                });
                window.EGTD_JackpotWidget({
                    el: widget_3,
                    type: !isMobile  ? 'horizontal' : 'compact-card',
                    jackpot: 'High Cash',
                    currency: 'TRY',
                    apiHost: process.env.VUE_APP_EGT_URL
                });
            }
        };
        
        // Append script to head
        document.head.appendChild(script);
    }
}
</script>

